import { Check } from '@mui/icons-material';
import { Box, Stack, SxProps, Typography } from '@mui/material';
import React from 'react';

const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

type BenefitCardProps = {
  label?: string;
  price: number;
  priceDetails?: string | React.ReactNode;
  benefits: Array<string | React.ReactNode>;
  sx?: SxProps;
};

export function BenefitCard({ label, price, priceDetails, benefits, sx }: BenefitCardProps) {
  return (
    <Stack
      sx={{
        bgcolor: 'background.default',
        borderRadius: '24px',
        padding: '40px 24px 56px 24px',
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
        width: '340px',
        ...sx,
      }}
    >
      {label && (
        <Typography variant='titleLarge' color='secondary.main'>
          {label}
        </Typography>
      )}
      <Stack alignItems='center'>
        <Typography variant='displayMedium' color='textPrimary'>
          {price === 0 ? 'FREE' : USDollar.format(price)}
        </Typography>
        <Typography variant='bodyMedium' color='textSecondary' textAlign='center'>
          {priceDetails || <br />}
        </Typography>
      </Stack>
      <Stack gap={2}>
        {benefits.map(benefit => (
          <Benefit key={benefit?.toString()}>{benefit}</Benefit>
        ))}
      </Stack>
    </Stack>
  );
}

function Benefit({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ position: 'relative', paddingLeft: '26px' }}>
      <Check sx={{ position: 'absolute', top: 2, left: 0, color: 'secondary.main' }} fontSize='small' />
      <Typography variant='bodyLarge' color='text.secondary'>
        {children}
      </Typography>
    </Box>
  );
}
